import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner,
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Link, useNavigate} from 'react-router-dom';
import AttributeUtil from "../../../../../../utils/orders/AttributeUtil";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import ModalConfirm from "../../../../modal/ModalConfirm";
import OrderService from "../../../../../../API/orders/orders/organization/OrderService";
import UpdateOrderModal from "./UpdateOrderModal";
import CreateNewOrderModal from "./CreateNewOrderModal";
import {orderStatus} from "../../../../../../data/OrderStatus";
import ButtonCreate from "../../../../button/ButtonCreate";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {ruRU} from "@mui/x-date-pickers/locales";
import selectionTableUtil, {normalizeSelection} from "../../../../../../utils/common/SelectionTableUtil";
import {Tooltip} from "@mui/material";
import DateRangeFilter from "../../../../filter/DateRangeFilter";
import OrderFolderNameCell from "./OrderFolderNameCell";
import OrderUtil from "../../../../../../utils/orders/OrderUtil";


const OrderTable = ({
                        data,
                        setData,
                        customerList,
                        nameList,
                        modelList,
                        attributeList,
                        planningList,
                        numberList,
                        numberCustomerList,
                        isIssuingEdge,
                        forWriteOff,
                        statusList,
                        archive,
                        rowSelection,
                        setRowSelection,
                        tableOptions,
                        tableOptionsHandle,
                        handleModalAlert,
                        enableRowSelection = true,
                        planning,
                        globalFilter,
                        handleSearchQuery,
                        filteredData,
                        columnsFilter,
                        setLists
                    }) => {
    const tableContainerRef = useRef(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [updateModalOpen, setUpdateModalOpen] = useState(false);

    const [sendArchiveModalOpen, setSendArchiveModalOpen] = useState(false);
    const [deleteConformModalOpen, setDeleteConformModalOpen] = useState(false);
    const [copyConformModalOpen, setCopyConformModalOpen] = useState(false);

    const [currentEditRowData, setCurrentEditRowData] = useState(null);
    const [dateOfReceipt, setDateOfReceipt] = useState(null);
    const [dateOfPlannedProduction, setDateOfPlannedProduction] = useState(null);
    const [plannedDateOfShipment, setPlannedDateOfShipment] = useState(null);
    const [manufactured, setManufactured] = useState(null);
    const [shipped, setShipped] = useState(null);
    const [currentEditRowId, setCurrentEditRowId] = useState(null);
    const [defaultAttributeId, setDefaultAttributeId] = useState(null);
    const navigate = useNavigate();
    const [showColumnFilters, setShowColumnFilters] = useState(false)
    const [loading, setLoading] = useState(false)

    const handleShowColumnFilters = () => {
        setShowColumnFilters(!showColumnFilters)
        if (showColumnFilters) {
            handleSearchQuery([], data, null, true)
        }
    }

    const redirectPlans = () => {
        navigate('/organization/plans');
    };

    const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
    const currentSelection = normalizeSelection(rowSelection)

    const onSubmit = (values, customerId, customerName, modelHeaderId, attributeId, orderType) => {
        setLoading(true)
        OrderService.save(values, customerId, customerName, modelHeaderId, attributeId, orderType).then(function (response) {
            const newData = [response.data, ...data]
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleModalAlert("Заказ создан", 'success')
            setLists(newData)
        })
            .catch(function (error) {
                handleModalAlert(error, 'error')
            })
            .finally(() => setLoading(false))
    };

    const handleUpdate = (values, modelHeaderId) => {
        setLoading(true)
        OrderService.update(values, modelHeaderId).then(function (response) {
            if (response.data.status === "SHIPPED" && !forWriteOff) {
                const newData = data.filter(el => el.id !== response.data.id)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                setLists(newData)
            } else {
                const newData = data.map(el => el.id === response.data.id ? response.data : el)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                setLists(newData)
            }
            handleModalAlert("Заказ изменён", 'success')

        })
            .catch(function (error) {
                handleModalAlert(error, 'error')
            })
            .finally(() => setLoading(false))
    };

    const handleUpdateModel = useCallback(
        (row) => {
            setCurrentEditRowData(row);
            setDateOfReceipt(row.dateOfReceipt);
            setDateOfPlannedProduction(row.dateOfPlannedProduction)
            setPlannedDateOfShipment(row.plannedDateOfShipment)
            setManufactured(row.manufactured)
            setShipped(row.shipped)
            setCurrentEditRowId(row.id);
            setUpdateModalOpen(true);
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );

    const sendToArchive = useCallback(
        (row) => {
            setCurrentEditRowData(row);
            setSendArchiveModalOpen(true);
        },
        [data, currentEditRowData, setCurrentEditRowData],
    );

    const handleSubmitSendToArchive = () => {
        setLoading(true)
        OrderService.sendToArchive(currentEditRowData.id)
            .then(function () {
                const newData = data.filter(el => el.id !== currentEditRowData.id)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleCloseModalSendToArchive()
                handleModalAlert("Заказ отправлен в архив", 'success')
                setLists(newData)
            })
            .catch(function (error) {
                handleModalAlert(error, 'error')
            })
            .finally(() => setLoading(false))
    };

    const handleCloseModalSendToArchive = () => {
        setSendArchiveModalOpen(false);
        setDeleteConformModalOpen(false);
        setCopyConformModalOpen(false);
        setCurrentEditRowData(null)
    };

    const handleDeleteRow = (row) => {
        setDeleteConformModalOpen(true)
        setCurrentEditRowData(row);
    }
    const handleCopyRow = (row) => {
        setCopyConformModalOpen(true)
        setCurrentEditRowData(row);
    }
    const handleDelete = () => {
        setLoading(true)
        OrderService.delete(currentEditRowData.id)
            .then(function () {
                const newData = data.filter(el => el.id !== currentEditRowData.id)
                setData(newData)
                handleSearchQuery(globalFilter, newData)
                handleCloseModalSendToArchive()
                handleModalAlert("Заказ удалён", 'success')
                setLists(newData)
            })
            .catch(function (error) {
                handleModalAlert(error, 'error')
            })
            .finally(() => setLoading(false))
    }
    const handleCopy = () => {
        setLoading(true)
        OrderService.copy(currentEditRowData.id).then(function (response) {
            const newData = [response.data, ...data]
            setData(newData)
            handleSearchQuery(globalFilter, newData)
            handleCloseModalSendToArchive()
            handleModalAlert("Заказ скопирован", 'success')
        })
            .catch(function (error) {
                handleModalAlert(error, 'error')
            })
            .finally(() => setLoading(false))
    }

    const columns = useMemo(() => {
        const baseColumns = [
            {
                id: 'number',
                header: '№ заказа',
                accessorKey: 'number',
                filterVariant: 'multi-select',
                filterSelectOptions: numberList,
                size: 140,
                minSize: 120,
                maxSize: 160,
                grow: false,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказа',
                    sx: {width: '200px'},
                },
                Cell: ({row, cell}) => {
                    const headerValue = row.original.header;
                    let header = null
                    if (headerValue !== null) {
                        header = headerValue.id;
                    }
                    return (
                        <OrderFolderNameCell order={row.original}>
                            <Tooltip arrow placement="bottom" title={row.original.number}>
                                <Box
                                    sx={{
                                        width: "100%",
                                        maxWidth: "100%",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                    }}
                                >
                                    {isIssuingEdge ? cell.getValue() : (
                                        <Link
                                            to={'/organization/orders/' + row.original.id + '/' + encodeURIComponent(cell.getValue()) + '/' + header + '/' + row.original.year}
                                        >
                                            {cell.getValue() === null ? 'Не занумерован' : cell.getValue()}
                                        </Link>
                                    )}
                                </Box>
                            </Tooltip>
                        </OrderFolderNameCell>
                    );
                }
            },
            {
                id: 'customer',
                header: 'Заказчик',
                accessorKey: 'customerName',
                enableStickyHeader: true,
                enableStickyFooter: true,
                enableGrouping: true,
                enableEditing: false,
                filterVariant: 'multi-select',
                filterSelectOptions: customerList,
                size: 200,
                minSize: 160,
                maxSize: 260,
                grow: false,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по заказчик',
                    sx: {
                        width: '200px',
                    },
                },
                Cell: ({row}) => <Tooltip arrow placement="bottom"
                                                title={row.original.customerName}><Box
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    }}>{row.original.customerName}</Box>
                </Tooltip>
            },
            {
                id: 'header',
                header: 'Наименование',
                accessorFn: (row) => row.header?.name,
                filterVariant: 'multi-select',
                filterSelectOptions: nameList,
                enableGrouping: true,
                size: 160,
                minSize: 120,
                maxSize: 220,
                grow: false,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по наименование',
                    sx: {
                        width: '200px',
                    },
                }
            },
            {
                id: 'plan',
                header: 'План',
                accessorFn: (row) => row.plan?.name,
                filterVariant: 'multi-select',
                filterSelectOptions: planningList,
                size: 120,
                minSize: 100,
                maxSize: 160,
                grow: false,
                Cell: ({cell, row}) => (
                    <>
                        {row.original?.plan !== null && (
                            <Link
                                to={'/organization/plans/' + row.original?.plan?.id + "/" + encodeURIComponent(row.original?.plan?.name)}
                                style={{
                                    display: 'block',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >{row.original?.plan?.name}</Link>
                        )}
                    </>
                ),
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по план',
                    sx: {
                        width: '170px',
                    },
                }
            },
            {
                accessorFn: (row) => {
                    if (row.dateOfPlannedProduction === null) {
                    } else {
                        return new Date(row.dateOfPlannedProduction)
                    }
                },
                id: 'dateOfPlannedProduction',
                header: 'План. пр.',
                sortingFn: 'datetime',
                size: 110,
                minSize: 100,
                maxSize: 130,
                grow: false,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            },

            {
                id: 'year',
                header: 'год                                                                     ',
                accessorKey: 'year',
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
            {
                header: 'id',
                accessorKey: 'id',
                enableHiding: false,
                enableColumnActions: false,
                enableGrouping: false,
                enableColumnFilter: false,
                enableEditing: false,
            },
        ];

        if (!isIssuingEdge) {
            baseColumns.splice(2, 0, {
                id: 'numberCustomer',
                header: '№ заказчика',
                accessorKey: 'numberCustomer',
                filterVariant: 'multi-select',
                filterSelectOptions: numberCustomerList,
                size: 140,
                minSize: 120,
                maxSize: 180,
                grow: false,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по № заказчика',
                    sx: {width: '200px'},
                },
                Cell: ({row, cell}) => <Tooltip arrow placement="bottom"
                                                title={row.original.numberCustomer}>
                    <Box
                        style={{
                            width: "100%",
                            maxWidth: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>{row.original.numberCustomer}</Box>
                </Tooltip>
            });
        }

        if (!isIssuingEdge) {
            const headerIndex = baseColumns.findIndex((column) => column.id === 'header');
            baseColumns.splice(headerIndex + 1, 0, {
                id: 'models',
                header: 'Модели',
                accessorFn: (row) => OrderUtil.getEstimateModuleNames(row).join(', '),
                filterVariant: 'multi-select',
                filterSelectOptions: modelList,
                enableGrouping: true,
                enableEditing: false,
                size: 180,
                minSize: 120,
                maxSize: 220,
                grow: false,
                Cell: ({row}) => {
                    const names = OrderUtil.getEstimateModuleNames(row.original);
                    if (!names.length) {
                        return null;
                    }
                    return (
                        <Box sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            maxWidth: '100%',
                            overflow: 'hidden',
                        }}>
                            {names.map((name, index) => (
                                <Box
                                    key={`${name}-${index}`}
                                    sx={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                    title={name}
                                >
                                    {name}
                                </Box>
                            ))}
                        </Box>
                    );
                },
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по модели',
                    sx: {
                        width: '200px',
                    },
                }
            });
        }

        if (!isIssuingEdge) {
            baseColumns.splice(5, 0, {
                accessorFn: (originalRow) => new Date(originalRow.dateOfReceipt), //convert to date for sorting and filtering
                id: 'dateOfReceipt',
                header: 'Поступление',
                size: 120,
                minSize: 110,
                maxSize: 140,
                grow: false,
                Cell: ({cell}) => cell.getValue().toLocaleDateString("en-GB"),
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            });
        }

        {
            baseColumns.splice(isIssuingEdge ? 5 : 6, 0, {
                id: 'status',
                header: 'Статус',
                accessorKey: 'status',
                filterVariant: 'multi-select',
                filterSelectOptions: statusList,
                Cell: ({cell}) => orderStatus[cell.getValue()],
                enableGrouping: true,
                size: 130,
                minSize: 110,
                maxSize: 160,
                grow: false,
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по статус',
                    sx: {
                        width: '170px',
                    },
                }
            });
        }

        if (!isIssuingEdge) {
            baseColumns.splice(7, 0, {
                id: 'attributes',
                header: 'Атрибуты',
                accessorKey: 'attributes',
                filterVariant: 'multi-select',
                filterSelectOptions: attributeList,
                size: 160,
                minSize: 120,
                maxSize: 220,
                grow: false,
                Cell: ({cell, row}) => (
                    <Link
                        to={'/organization/orders/set-attribute/' + row.original.id + '/' + encodeURIComponent(row.original.number) + '/'
                            + row.original.header?.id + '/' + row.original.year}
                        style={{
                            display: 'block',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >{row.original.attributes.length === 0 ? 'Не устанволен' : AttributeUtil.convertAttributes(cell.getValue())}</Link>
                ),
                muiFilterTextFieldProps: {
                    placeholder: 'Отфильтровать по атрибуты',
                    sx: {
                        width: '170px',
                    },
                }
            });
        }

        if (!isIssuingEdge) {
            baseColumns.splice(11, 0, {
                id: 'manufactured',
                header: 'Произв.',
                accessorFn: (row) => {
                    if (row.manufactured === null) {
                    } else {
                        return new Date(row.manufactured)
                    }
                },
                sortingFn: 'datetime',
                size: 110,
                minSize: 100,
                maxSize: 130,
                grow: false,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            });
        }

        if (!isIssuingEdge) {
            baseColumns.splice(12, 0, {
                accessorFn: (row) => {
                    if (row.plannedDateOfShipment === null) {
                    } else {
                        return new Date(row.plannedDateOfShipment)
                    }
                },
                id: 'plannedDateOfShipment',
                header: 'План. отг.',
                sortingFn: 'datetime',
                size: 110,
                minSize: 100,
                maxSize: 130,
                grow: false,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            });
        }

        if (!isIssuingEdge && !planning) {
            baseColumns.splice(12, 0, {
                accessorFn: (row) => {
                    if (row.shipped === null) {
                    } else {
                        return new Date(row.shipped)
                    }
                },
                id: 'shipped',
                header: 'Отгружено',
                sortingFn: 'datetime',
                size: 110,
                minSize: 100,
                maxSize: 130,
                grow: false,
                Cell: ({cell}) => {
                    if (cell.getValue() !== undefined) {
                        return cell.getValue().toLocaleDateString('en-GB');
                    }
                },
                Filter: ({column}) => <DateRangeFilter
                    column={column}
                />,
            });
        }

        return baseColumns;

    }, [data, setData, isIssuingEdge, filteredData, customerList, nameList, modelList, attributeList, planningList, statusList, numberList, numberCustomerList, forWriteOff, planning]);

    const menuItem = forWriteOff ? [
        {type: "edit", text: "Редактировать", handler: handleUpdateModel},
        {type: "archive", text: "Поместить в архив", handler: sendToArchive}
    ] : planning ? [{type: "edit", text: "Редактировать", handler: handleUpdateModel}] : [
        {type: "edit", text: "Редактировать", handler: handleUpdateModel},
        {type: "copy", text: "Скопировать заказ", handler: handleCopyRow},
        {type: "delete", text: "Удалить", handler: handleDeleteRow},
    ]

    return (
        <Box sx={{width: "100%"}}>
            <Box
                sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
            >
                <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "9px"}}>
                    {!isIssuingEdge && <ButtonCreate
                        text={"Планы"}
                        width={70}
                        icon={false}
                        onClick={redirectPlans}
                    />}
                    {!isIssuingEdge && !forWriteOff && !planning && <ButtonCreate
                        text={"Создать заказ"}
                        width={170}
                        onClick={() => setCreateModalOpen(true)}
                    />}
                </Box>
            </Box>
            <Box sx={{overflow: 'auto', width: "100%"}}>
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale='ru'
                    localeText={ruRU.components.MuiLocalizationProvider.defaultProps.localeText}>
                    <MaterialReactTable
                        muiTableContainerProps={{
                            ref: tableContainerRef,
                            sx: {
                                maxHeight: rowSelection?.length > 0 ? `calc(100vh - 550px)` : `calc(100vh - 450px)`,
                                width: "100%",
                            }
                        }}
                        muiTableProps={{
                            sx: {
                                width: "100%",
                                minWidth: "2000px",
                                tableLayout: "fixed",
                            }
                        }}

                        muiTopToolbarProps={{
                            sx: {
                                "& .MuiBox-root": {
                                    padding: 0
                                }
                            }
                        }}
                        muiTableHeadCellProps={{
                            sx: {
                                border: '1px solid #EAEBEA',
                                backgroundColor: "#F5F6FA",
                                padding: "10px",
                                paddingBottom: " 0.2rem",
                                paddingTop: "0.2rem",
                                "&:first-of-type .Mui-TableHeadCell-Content-Wrapper": {
                                    "minWidth": "100%"
                                },
                                "& .MuiCollapse-root .MuiSelect-select": {
                                    padding: "0 !important",
                                    "& .MuiChip-label": {
                                        paddingLeft: "5px",
                                        paddingRight: "5px",
                                    }
                                }
                            },
                        }}
                        muiTableBodyCellProps={{
                            sx: {
                                p: '0px 0px 0px 10px',
                                m: '0px 0px 0px 0px',
                                border: "none",

                                "&:after": {
                                    display: "none",
                                },
                                "&:not(:last-of-type)": {
                                    borderRight: '1px solid #EAEBEA',

                                },
                                "&:first-of-type": {
                                    padding: 0,
                                    width: "50px",
                                    height: "36px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    color: (theme) => theme.palette.text.light,
                                    "& .MuiButtonBase-root": {
                                        borderRadius: "4px",
                                        width: "24px",
                                        height: "24px",
                                        opacity: 1,
                                        margin: 0,
                                        padding: 0,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        }
                                    }
                                },
                                "& a": {
                                    color: "#006CCC",
                                    textDecoration: "none",

                                    "&:hover": {
                                        textDecoration: "underline"
                                    }

                                }
                            },
                        }}

                        muiTableBodyRowProps={({row}) => {
                            return ({
                                sx: () => ({
                                    height: '36px',
                                    backgroundColor: "white",
                                    "&:hover& td:after": {
                                        display: "none",
                                    },
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light70,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        "& td:after": {
                                            display: "none",
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                    '&:nth-of-type(even)': {
                                        "&.MuiTableRow-root.Mui-selected": {
                                            backgroundColor: (theme) => theme.palette.primary.light,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.light50,
                                            },
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        },
                                    },
                                })
                            })
                        }}

                        muiSearchTextFieldProps={{
                            placeholder: `Поиск`,
                            sx: {
                                paddingTop: "5px",
                                paddingBottom: "0px",
                                // '& .MuiInputBase-input': {
                                "-internal-autofill-selected": {
                                    backgroundColor: "transparent !important",
                                },
                                // },
                                "& .MuiCollapse-root": {
                                    borderRadius: '12px',
                                    height: 40, width: 290,
                                    "& .MuiSvgIcon-root": {
                                        color: "#737478"
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: 0
                                    }
                                }
                            },
                            variant: 'outlined',
                        }}
                        displayColumnDefOptions={{
                            'mrt-row-actions': {
                                header: "",
                                size: 36,
                                minSize: 32,
                                maxSize: 40,
                                grow: false,
                            },
                            'mrt-row-select': {
                                size: 36,
                                minSize: 32,
                                maxSize: 40,
                                grow: false,
                            },
                        }}
                        columns={columns}
                        data={filteredData}
                        onRowSelectionChange={onRowSelectionChange}
                        onPaginationChange={(updater) => {
                            tableOptionsHandle(updater(tableOptions));
                        }}
                        onGlobalFilterChange={(value) => {
                            handleSearchQuery(value, data, null)
                        }}
                        onColumnFiltersChange={(updater) => {
                            handleSearchQuery(updater(columnsFilter), data, null, true)
                        }}
                        onShowColumnFiltersChange={handleShowColumnFilters}
                        state={{
                            showColumnFilters: showColumnFilters,
                            columnFilters: columnsFilter,
                            globalFilter: globalFilter,
                            rowSelection: currentSelection,
                            showGlobalFilter: true,
                            pagination: tableOptions,
                        }}
                        manualFiltering={true}
                        rowCount={tableOptions.totalElements}
                        enableRowSelection={enableRowSelection}
                        selectionPadding={1}
                        getRowId={(originalRow) => originalRow.id}
                        selectionCss={{
                            backgroundColor: 'lightblue',
                            borderWidth: '2px',
                            borderStyle: 'solid',
                            borderColor: 'blue',
                            borderRadius: '4px',
                        }}
                        initialState={{
                            columnVisibility: {
                                id: false,
                                model: false,
                                year: false,
                            },
                            isFullScreen: false,
                            density: "compact",
                        }}
                        localization={MRT_Localization_RU}
                        enableRowActions={!isIssuingEdge}
                        enableToolbarInternalActions={false}
                        selectAllMode={"all"}
                        renderTopToolbar={({table}) => {
                            return <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "7px",
                                backgroundColor: (theme) => rowSelection?.length > 0 ? theme.palette.primary.light : "transparent",
                            }}>
                                <MRT_ToolbarAlertBanner table={table}/>
                                <Box sx={{display: "flex"}}>
                                    <MRT_ToggleFiltersButton table={table}/>
                                    <MRT_GlobalFilterTextField table={table}/>
                                </Box>
                            </Box>
                        }}
                        muiToolbarAlertBannerProps={{
                            sx: {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "& .MuiStack-root": {
                                    padding: 0,
                                },
                            }
                        }}

                        renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                            return <MenuItem
                                key={el.type}
                                disabled={el.type === "delete" && row.original.dateOfConstructorDocumentation}
                                onClick={() => {
                                    el.handler(row.original)
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                                }}
                            >
                                {el.text}
                            </MenuItem>
                        })}
                    />
                </LocalizationProvider>
            </Box>
            <CreateNewOrderModal
                columns={columns}
                open={createModalOpen}
                onClose={() => setCreateModalOpen(false)}
                onSubmit={onSubmit}
                customerList={customerList}
                defaultAttributeId={defaultAttributeId}
                setDefaultAttributeId={setDefaultAttributeId}
                handleModalAlert={handleModalAlert}
                loading={loading}
            />
            {updateModalOpen && <UpdateOrderModal
                open={updateModalOpen}
                onClose={() => setUpdateModalOpen(false)}
                onSubmit={handleUpdate}
                values={currentEditRowData}
                currentEditRowId={currentEditRowId}
                setValues={setCurrentEditRowData}
                dateOfReceipt={dateOfReceipt}
                setDateOfReceipt={setDateOfReceipt}
                dateOfPlannedProduction={dateOfPlannedProduction}
                setDateOfPlannedProduction={setDateOfPlannedProduction}
                plannedDateOfShipment={plannedDateOfShipment}
                setPlannedDateOfShipment={setPlannedDateOfShipment}
                manufactured={manufactured}
                setManufactured={setManufactured}
                shipped={shipped}
                setShipped={setShipped}
                handleModalAlert={handleModalAlert}
                forWriteOff={forWriteOff}
                loading={loading}
            />}
            <ModalConfirm
                title={deleteConformModalOpen ? "Подтвердить удаление" : copyConformModalOpen ? "Подтвердить скопировать заказ?" : "Подтвердить поместить в архив"}
                modalOpen={sendArchiveModalOpen || deleteConformModalOpen || copyConformModalOpen}
                handleClose={handleCloseModalSendToArchive}
                handleSubmit={deleteConformModalOpen ? handleDelete : copyConformModalOpen ? handleCopy : handleSubmitSendToArchive}
                action={"Подтвердить"}
                loading={loading}
            />
        </Box>
    );
};

export default OrderTable;